import { render } from "./OnlineCollaborators.vue?vue&type=template&id=f3894034&scoped=true"
import script from "./OnlineCollaborators.vue?vue&type=script&lang=js"
export * from "./OnlineCollaborators.vue?vue&type=script&lang=js"

import "./OnlineCollaborators.vue?vue&type=style&index=0&id=f3894034&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f3894034"

export default script